import { trigger, transition,state, style, animate } from '@angular/animations';

export const rotate_view = trigger('rotate_view', [
    state('out', style({ transform: 'rotate(0)' })),
    state('in', style({ transform: 'rotate(-180deg)' })),
    transition('in <=> out', animate('400ms ease-out')),
]);